module.exports = "/hwa/_next/static/images/trees-3e4646ff1dc779b43a8406c5e3ed0c05.png";